import { useEffect, useState } from "react";
import { Trophy, Gift } from "lucide-react";
import adminApi from "@/lib/adminApi";
import { fmtNaira } from "@/lib/api";

export default function AdminReferrals() {
  const [board, setBoard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get("/admin/referrals")
      .then((r) => setBoard(r.data.leaderboard || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 md:p-8 max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="font-heading text-3xl font-bold flex items-center gap-2"><Trophy className="w-6 h-6 text-amber-500" /> Referral leaderboard</h1>
        <p className="text-sm text-kudi-ink/60">Top traders bringing friends</p>
      </div>

      <div className="bg-white border border-border rounded-2xl overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-kudi-ink/40">Loading...</div>
        ) : board.length === 0 ? (
          <div className="p-8 text-center">
            <Gift className="w-10 h-10 mx-auto text-kudi-ink/30 mb-2" />
            <div className="text-kudi-ink/50">No referrals yet</div>
          </div>
        ) : board.map((row, i) => (
          <div key={row.code} className="flex items-center gap-4 p-4 border-b border-border/40 last:border-b-0" data-testid={`ref-row-${i}`}>
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold ${
              i === 0 ? "bg-amber-100 text-amber-700" :
              i === 1 ? "bg-slate-100 text-slate-700" :
              i === 2 ? "bg-orange-100 text-orange-700" :
              "bg-accent text-kudi-green"
            }`}>
              {i + 1}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium">{row.inviter?.owner_name || "Unknown"}</div>
              <div className="text-xs text-kudi-ink/55 font-mono">{row.code}</div>
            </div>
            <div className="text-right">
              <div className="font-heading text-lg font-bold tabular-nums">{row.count}</div>
              <div className="text-xs text-kudi-ink/55">Earned {fmtNaira(row.count * 500)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
